module.exports = __webpack_public_path__ + "img/mobile-01_2.23a9253f.png";